import React, { ReactNode } from 'react';
import { States } from '@/helpers/common/states';
import Event from '@/model/Event';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { Dialog, Loading } from '@/components';
import { Column, ResponsiveDataGrid } from '@/components/TableReponsive';
import Pagination from '@/components/Utils/Pagination';
import Page from '@/model/Page';
import FilterVector from '@/assets/images/svg/FilterVector';
import { ActionProps } from '@/components/Dialog';
import { Container } from 'reactstrap';
import { FilterContentEvent } from '../../../components/FilterContentEvent';

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
}

interface Props {
  state: States;
  currentPage: Page<Event, Event>;
  formData: FormData;
  formErrors: FormErrors;
  title: string | ReactNode;
  visible: boolean;
  shouldShowModal: ShouldShowModal;
  goTocancel: (id: string) => void;
  onChangeFormInput: OnChangeFormInput;
  onFilter: () => void;
  clearFilter: () => void;
  onPagination: (page: number) => void;
  onShouldShowModal: ({
    value,
    newTitleModal,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
  }) => void;
  onToggle: () => void;
}

export const EventCancelTicketsUI: React.FC<Props> = ({
  state,
  currentPage,
  formData,
  formErrors,
  title,
  visible,
  shouldShowModal,
  goTocancel,
  onChangeFormInput,
  onFilter,
  clearFilter,
  onPagination,
  onShouldShowModal,
  onToggle,
}): JSX.Element => {
  const columns: Column<Event>[] = [
    {
      key: 'imageBase64',
      header: '',
      width: '120px',
      align: 'center',
      render: row => (
        <img
          src={row.imageBase64}
          alt={row.name}
          style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 8 }}
        />
      ),
    },
    {
      key: 'name',
      header: 'Nome do Evento',
      sortable: true,
      render: row => row.name,
    },
    {
      key: 'startDate',
      header: 'Início',
      width: '180px',
      sortable: true,
      render: row =>
        new Date(row.startDate).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
    },
    {
      key: 'endDate',
      header: 'Fim',
      width: '180px',
      sortable: true,
      render: row =>
        new Date(row.endDate).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }),
    },
  ];

  const renderActionDialogToCancelFilter: ActionProps = {
    title: 'Limpar',
    onClick: (): void => clearFilter(),
    theme: 'noneBorder',
  };

  return (
    <>
      <Loading isVisible={state === States.loading} />
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        footerBorder={'top'}
        position={shouldShowModal === ShouldShowModal.filter ? 'right' : 'center'}
        isContentWithCard={shouldShowModal !== ShouldShowModal.filter}
        actions={[
          {
            [ShouldShowModal.filter]: renderActionDialogToCancelFilter,
          }[shouldShowModal],
          {
            [ShouldShowModal.filter]: {
              title: 'Aplicar',
              onClick: onFilter,
            },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.filter]: (
              <FilterContentEvent
                formData={formData}
                formErrors={formErrors}
                onChangeFormInput={onChangeFormInput}
              />
            ),
          }[shouldShowModal]
        }
      </Dialog>
      <Container className="mainContainer" fluid={true}>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '30px' }}>
          <h5 className="pageTitle">Cancelar Pedido ADM</h5>
          <div className="button-filter-container">
            <div className="filter-container">
              <div
                className="filter-content"
                onClick={(): void => {
                  onShouldShowModal({ value: ShouldShowModal.filter, newTitleModal: '' });
                }}
              >
                <FilterVector />
              </div>
            </div>
          </div>
        </div>
        <ResponsiveDataGrid<Event>
          columns={columns}
          page={{
            list: currentPage.list,
            page: currentPage.page,
            pageSize: currentPage.pageSize,
            total: currentPage.total,
          }}
          initialSortKey="startDate"
          initialSortDir="asc"
          onRowClicked={row => goTocancel(row.id)}
          emptyMessage="Nenhum evento encontrado."
        />
        <Pagination
          currentPage={currentPage.page}
          totalCount={currentPage.total}
          pageSize={currentPage.pageSize}
          onPageChange={(page: number) => onPagination(page)}
          total={currentPage.total}
        />
      </Container>
    </>
  );
};
